import { gql } from "lib/apolloClient";

export const fetchThirdPartyDriveAttachmentRevisionDataQuery = gql`
  query fetchThirdPartyDriveAttachmentRevisionData($id: ID!) {
    node(id: $id, type: ATTACHMENT) {
      id
      ... on Attachment {
        thirdPartyDriveAttachmentRevisionData {
          isSuccess
          response
          warning
        }
      }
    }
  }
`;
